import { render, staticRenderFns } from "./IconMessageNote.vue?vue&type=template&id=d7117c72"
import script from "./IconMessageNote.vue?vue&type=script&lang=js"
export * from "./IconMessageNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports